import { toast } from 'react-hot-toast';
import { useEffect, useRef } from 'react';
import { useMessages } from '../../../hooks/useMessages';
import { editChatMessage } from '../../../services/fetch-utils';
import { ChatMessages } from '../../../interfaces/userInterfaces';

export const EditDirectMessage = () => {
  const { messageToEdit, setEditingMessage } = useMessages();

  //   chatRef is the text value from the text area in the form
  const chatRef = useRef<HTMLTextAreaElement>(null);

  //   editedMessageRef is the single message chat object
  const editedMessageRef = useRef<ChatMessages>({} as ChatMessages);

  useEffect(() => {
    if (messageToEdit.id !== undefined && chatRef.current) {
      chatRef.current.value = messageToEdit.message;
    }
  }, [messageToEdit]);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.style.height = 'auto';
      chatRef.current.style.height = `${chatRef.current.scrollHeight}px`;
    }
  }, [chatRef]);

  const resetEditValues = () => {
    if (chatRef.current) {
      chatRef.current.value = '';
      editedMessageRef.current = {} as ChatMessages;
      setEditingMessage(false);
    }
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (messageToEdit.id !== undefined && chatRef.current) {
      editedMessageRef.current.message = chatRef.current.value;
      const response = editChatMessage(messageToEdit.id, editedMessageRef.current.message)
        .catch((error) => error.message)
        .then(() => {
          resetEditValues();
        });

      toast.promise(
        response,
        {
          loading: 'Just a moment while we edit your Message',
          success: 'Message successfully edited',
          error: 'Oops! Something went wrong. Please try again.',
        },
        {
          duration: 1000,
        }
      );
    }
  };

  return (
    <form id="edit-message-form" onSubmit={handleSubmit}>
      <label id="edit-message-input-label">Edit Message</label>
      <textarea
        ref={chatRef}
        id="edit-message-text-area"
        placeholder="Speak Your Mind..."
      ></textarea>
      <span id="edit-message-button-group">
        <button className="message-send-btn" type="submit">
          Submit Edit
        </button>
        <button className="message-send-btn" type="button" onClick={() => resetEditValues()}>
          Cancel Edit
        </button>
      </span>
    </form>
  );
};
